import React from 'react';
import { Container, Title, Subtitle, ImageContainer } from './style';

export const Card = ({ image: Image = null, title = null, subtitle = null }) => {
    return (
        <Container>
            {Image && <ImageContainer><Image /></ImageContainer>}
            <div>
                {title && <><Title dangerouslySetInnerHTML={{ __html: title }} /></>}
                {subtitle &&  <><Subtitle dangerouslySetInnerHTML={{ __html: subtitle }} /></>}
            </div>
        </Container>
    );
}